import { ActionReducerMapBuilder, nanoid } from '@reduxjs/toolkit'
import {
  actualizeJob,
  createFromUrl,
  fetchAllJobsFiltered,
  ssmlToAudio,
} from '@editor/store/thunks/job.thunk'
import { jobAdapterExport, JobModel } from '@editor/store/slices/job.slice'
import { EntityStateWithLoadingAndError } from '@editor/store/slices/generic.slice'

export const jobExtraReducers = (
  builder: ActionReducerMapBuilder<EntityStateWithLoadingAndError<JobModel>>
) => {
  builder
    //Create from url reducer
    .addCase(createFromUrl.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(createFromUrl.fulfilled, (state, action) => {
      state.loading = false
      jobAdapterExport.addOne(state, action.payload)
    })
    .addCase(createFromUrl.rejected, (state, action) => {
      state.loading = false
      state.error = (action.payload as string) || 'Could not fetch job details'
    })

    //Text to audio reducer
    .addCase(ssmlToAudio.pending, (state, action) => {
      state.inProgress = [action.meta.arg.jobId.toString(), ...state.inProgress]
      state.error = null
    })
    .addCase(ssmlToAudio.fulfilled, (state, action) => {
      state.inProgress = state.inProgress.filter(
        (id) => id !== action.meta.arg.jobId.toString()
      )
      jobAdapterExport.upsertOne(state, action.payload)
    })
    .addCase(ssmlToAudio.rejected, (state, action) => {
      state.inProgress = state.inProgress.filter(
        (id) => id !== action.meta.arg.jobId.toString()
      )
      state.error = (action.payload as string) || 'Could not fetch job details'
    })

    //Fetch all filtered reducer
    .addCase(fetchAllJobsFiltered.pending, (state, action) => {
      state.loading = true
      state.error = null
      state.requestId = action.meta.requestId
    })
    .addCase(fetchAllJobsFiltered.fulfilled, (state, action) => {
      // Only update models for latest request
      if (action.meta.requestId !== state.requestId) {
        return
      }
      state.loading = false
      jobAdapterExport.setMany(state, action.payload)
    })
    .addCase(fetchAllJobsFiltered.rejected, (state, action) => {
      state.loading = false
      state.error =
        (action.payload as string) || 'Could not fetch filtered jobs'
    })

    //Actualize reducer
    .addCase(actualizeJob.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(actualizeJob.fulfilled, (state, action) => {
      state.loading = false
      jobAdapterExport.upsertOne(state, action.payload)
    })
    .addCase(actualizeJob.rejected, (state, action) => {
      state.loading = false
      state.error = (action.payload as string) || 'Could actualize article'
    })
}
